import { useQuery } from '@tanstack/react-query'
import { superAdminApi } from '../services/super-admin-api'

// Types for the API response
export interface OrganizationDetail {
  id: string
  name: string
  slug: string
  subscription_status: string
  account_status: 'active' | 'suspended'
  trial_ends_at: string | null
  trial_days_remaining: number | null
  suspended_at: string | null
  suspension_reason: string | null
  created_at: string
  updated_at: string
  last_activity_at: string | null
  billing_email: string | null
  billing_name: string | null
  stripe_customer_id: string | null
  subscription: {
    id?: string
    status?: string
    plan_id?: string
    plan_name: string | undefined
    billing_interval: 'monthly' | 'yearly'
    current_period_start?: string
    current_period_end?: string
    mrr?: number
  } | null
  metrics: {
    active_members: number
    active_patients: number
    reports_30d: number
    messages_30d?: number
    engagement_score: number
  }
  alerts: {
    critical: number
    warning: number
  }
  mrr?: number
}

export function useOrganization(id: string | undefined) {
  return useQuery<OrganizationDetail>({
    queryKey: ['super-admin', 'organization', id],
    queryFn: async () => {
      return superAdminApi.get<OrganizationDetail>(`/organizations/${id}`)
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 2, // 2 minutes
  })
}
